import serverCall from "../serverCall";

const getAnalyticalData = async (country?: string) => {
    try {
        const response = serverCall.get('/analytical', { params: country ? { country: country } : {} })
        return response
    } catch (error) {
        throw error
    }
}

const getEvents = async (country?: string) => {
    try {
        const response = serverCall.get('/events', { params: country ? { country: country } : {} })
        return response
    } catch (error) {
        throw error
    }
}

const getEventsByid = async (id: string) => {
    try {
        const response = serverCall.get(`/events/${id}`)
        return response
    } catch (error) {
        throw error
    }
}

const getPresences = async () => {
    try {
        const response = serverCall.get('/presences/countries')
        return response
    } catch (error) {
        throw error
    }
}

const getImageSliderByCountry = async (country: string) => {
    try {
        const response = serverCall.get(`/homebanner/country?country=${country}`)
        return response
    } catch (error) {
        throw error
    }
}

const getProductByCountry = async (country: string) => {
    try {
        const response = serverCall.get(`/products/country?country=${country}`)
        return response
    } catch (error) {
        throw error
    }
}

const getTradeHistoryByCountry = async (country: string) => {
    try {
        const response = serverCall.get(`/tradehistory/country?country=${country}`)
        return response
    } catch (error) {
        throw error
    }
}

const getAnalyticalByCountry = async (country: string) => {
    try {
        const response = serverCall.get(`/analytical/country?country=${country}`)
        return response
    } catch (error) {
        throw error
    }
}

const getImageSliderByCategory = async (category: string) => {
    try {
        const response = serverCall.get(`/homebanner/category?category=${category}`)
        return response
    } catch (error) {
        throw error
    }
}

const getSpotMarketRateByCategory = async (category?: string, subCategory?: string) => {
    try {
        const response = serverCall.get('/dmr/market-data/category', { params: category || subCategory ? { category: category, subCategory: subCategory } : {} })
        return response
    } catch (error) {
        throw error
    }
}

const getCategoriesByCountry = async (country: string) => {
    try {
        const response = serverCall.get(`/categories/country?country=${country}`)
        return response
    } catch (error) {
        throw error
    }
}

const getProductsByCategory = async (category: string, season: string, subCategory?: string) => {
    try {
        let url = `/products?category=${category}&season=${season}`;
        if (subCategory && subCategory !== 'All') {
            url += `&subcategory=${subCategory}`;
        }
        const response = serverCall.get(url)
        return response
    } catch (error) {
        throw error
    }
}

const getContentOverViewByCategory = async (category: string) => {
    try {
        const response = serverCall.get(`/contentoverview/category?category=${category}`)
        return response
    } catch (error) {
        throw error
    }
}

const getMembership = async (country?: string) => {
    try {
        const response = serverCall.get('/membership', { params: country ? { country: country } : {} })
        return response
    } catch (error) {
        throw error
    }
}

const getAffiliation = async (country?: string) => {
    try {
        const response = serverCall.get('/affiliation', { params: country ? { country: country } : {} })
        return response
    } catch (error) {
        throw error
    }
}

const getProduct = async (country?: string) => {
    try {
        const response = serverCall.get('/products', { params: country ? { country: country } : {} })
        return response
    } catch (error) {
        throw error
    }
}

const getServices = async (country?: string) => {
    try {
        const response = serverCall.get('/financialservice', { params: country ? { country: country } : {} })
        return response
    } catch (error) {
        throw error
    }
}

const inquiryIR = async (value: any) => {
    try {
        const response = serverCall.post('/investorrelations', value)
        return response
    } catch (error) {
        throw error
    }
}

const getUpcomingCollaboration = async (country?: string) => {
    try {
        const response = serverCall.get('/upcoming_collaboration', { params: country ? { country: country } : {} })
        return response
    } catch (error) {
        throw error
    }
}

const HomePageservice = {
    getAnalyticalData, getEvents, getPresences, getImageSliderByCountry, getImageSliderByCategory,
    getProductByCountry, getSpotMarketRateByCategory, getTradeHistoryByCountry, getAnalyticalByCountry,
    getCategoriesByCountry, getProductsByCategory, getContentOverViewByCategory, getMembership, getAffiliation,
    getProduct, getServices, inquiryIR, getUpcomingCollaboration, getEventsByid
};

export default HomePageservice;